var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validated-section"},[_c('Icon',{staticClass:"check",class:{
      valid: _vm.valid,
      hidden: _vm.hideCheck,
      faded: _vm.fadeCheck
    },attrs:{"name":"check_circle_outline"}}),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }